import {_utils} from "../../utils/_utils.js";
import {_libs} from "../../utils/_libs.js";
import {_state} from "../../state/state.js";
import {watchPageHeight} from "../../utils/scroll-refresh.js";

/**
 * "An Icon, Designed Around You" — tabs (TZ, section 5).
 * - Default: the first tab is active (white + dot), the rest are 40%.
 * - ALL breakpoints (the user asked to keep this one on mobile too — an exception to the desktop-only rule):
 *   the panel is position: sticky inside a taller stage (CSS, 1.2 screens of scroll per tab); scroll progress
 *   through the stage picks the active tab — photo, icon and caption switch in sync; reverse scroll goes back.
 *   Clicking/tapping a tab scrolls to its part of the stage.
 */
export const hpIcon = () => {
    return new Promise((resolve) => {
        _utils.initSection('.hp-icon', (section) => init(section));
        watchPageHeight();
        resolve();
    });
};

const init = (section) => {
    const stage = section.querySelector('.hp-icon__stage');
    const tabs = [...section.querySelectorAll('.hp-icon__tab')];
    const images = [...section.querySelectorAll('.hp-icon__image')];
    const captions = [...section.querySelectorAll('.hp-icon__caption')];
    if (!stage || tabs.length < 2) return;

    let current = 0;
    let tl = null;

    const setActive = (index) => {
        if (index === current) return;
        current = index;

        tabs.forEach((tab, i) => {
            const active = i === index;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        images.forEach((image, i) => image.classList.toggle('is-active', i === index));
        captions.forEach((caption, i) => {
            caption.classList.toggle('is-active', i === index);
            caption.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
    };

    const createTl = () => {
        if (tl !== null) {
            tl.scrollTrigger && tl.scrollTrigger.kill(true);
            tl.kill();
            tl = null;
        }

        tl = _libs._gsap({
            trigger: stage,
            start: 'top top',
            end: 'bottom bottom',
            invalidateOnRefresh: true,
            //markers: true,
            onUpdate: (self) => {
                setActive(Math.min(tabs.length - 1, Math.floor(self.progress * tabs.length)));
            },
        });
    };

    createTl();

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            if (!tl || !tl.scrollTrigger) return;
            // scroll to the middle of this tab's slice of the stage
            const st = tl.scrollTrigger;
            const target = st.start + (st.end - st.start) * ((index + 0.5) / tabs.length);

            if (_state.lenisInit !== null) {
                _state.lenisInit.scrollTo(target, {duration: 1});
            } else {
                window.scrollTo({top: target, behavior: 'smooth'});
            }
        });
    });

    // Same behaviour on every breakpoint → no rebuild needed; size changes are handled by
    // ScrollTrigger.refresh() inside _libs._gsap (invalidateOnRefresh).

};
